import { render, staticRenderFns } from "./CustomSpinner.vue?vue&type=template&id=3a837dca"
import script from "./CustomSpinner.vue?vue&type=script&lang=js"
export * from "./CustomSpinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports